// Swap main product image when clicking thumbnails (no new page)
document.addEventListener('click', function(e){
  const btn = e.target.closest('.product-thumbs .thumb');
  if(!btn) return;
  e.preventDefault();
  const full = btn.getAttribute('data-full');
  const main = document.getElementById('ProductMainImage');
  if(full && main){
    main.setAttribute('src', full);
  }
});


// JUNK MAIL popups: password page after 10s, homepage after 50% scroll
(function(){
  function openModal(modal){
    if(!modal || sessionStorage.getItem(modalKey(modal)) === 'closed') return;
    modal.hidden = false;
  }
  function closeModal(modal){
    if(!modal) return;
    modal.hidden = true;
    sessionStorage.setItem(modalKey(modal), 'closed');
  }
  function modalKey(modal){
    if(modal.hasAttribute('data-junk-mail-password')) return 'junkMailPasswordClosed';
    return 'junkMailHomeClosed';
  }

  document.addEventListener('click', function(e){
    var close = e.target.closest('[data-junk-mail-close]');
    if(!close) return;
    closeModal(e.target.closest('.junk-mail-modal'));
  });

  var passwordModal = document.querySelector('[data-junk-mail-password]');
  if(passwordModal){
    window.setTimeout(function(){ openModal(passwordModal); }, 10000);
  }

  var scrollModal = document.querySelector('[data-junk-mail-scroll]');
  if(scrollModal){
    var shown = false;
    function checkScroll(){
      if(shown) return;
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if(scrollable <= 0) return;
      var progress = (window.scrollY || doc.scrollTop) / scrollable;
      if(progress >= 0.5){
        shown = true;
        openModal(scrollModal);
        window.removeEventListener('scroll', checkScroll);
      }
    }
    window.addEventListener('scroll', checkScroll, { passive: true });
    checkScroll();
  }
})();
